import { __decorate } from "tslib";
import Vue from "vue";
import Component from "vue-class-component";
import InstructorsTable from "@/components/InstructorsTable.vue";
import moment from "moment";
import _ from "lodash";
import OperatingHoursMapper from "@/classes/OperatingHoursMapper";
import AddClientForm from '@/components/AddClientForm.vue';
import { InstructorTableCellType } from '@/enums/InstructorTableCellType';
import { InstructorTableRowType } from '@/enums/InstructorTableRowType';
import Snackbar from '@/components/Snackbar.vue';
import InstructorTableAvailableCell from '@/classes/InstructorTableAvailableCell';
import { NotificationTypes } from "@/enums/NotificationTypes";
import { Ref, Watch } from "vue-property-decorator";
import { isDesktop } from "@/utils/isDesktop";
import { validateOverlap, formatOverlapError } from '@/utils/overlapValidation';
import { logActivity, createReservationEntityId } from '@/services/ActivityLogService';
let InstructorsTimeSchedule = class InstructorsTimeSchedule extends Vue {
    addClientDialogProps = {};
    filters = [
        { text: 'Lyže - Junior', value: 'ski-junior' },
        { text: 'Lyže - Medior', value: 'ski-medior' },
        { text: 'Lyže - Senior', value: 'ski-senior' },
        { text: 'Snowboard - Junior', value: 'snb-junior' },
        { text: 'Snowboard - Medior', value: 'snb-medior' },
        { text: 'Snowboard - Senior', value: 'snb-senior' },
        { text: 'WEX - Junior', value: 'wex-junior' },
        { text: 'WEX - Medior', value: 'wex-medior' },
        { text: 'WEX - Senior', value: 'wex-senior' },
        { text: 'Dětská školka - Junior', value: 'kid-school-junior' },
        { text: 'Dětská školka - Medior', value: 'kid-school-medior' },
        { text: 'Dětská školka - Senior', value: 'kid-school-senior' },
    ];
    activeFilters = [];
    controlsRow;
    dates = [moment()];
    // range: string[] = [
    //     this.dates[0]
    //         .subtract(this.dates[0].day() > 0 ? this.dates[0].day() - 1 : 6, "days")
    //         .format("YYYY-MM-DD"),
    //     _.cloneDeep(this.dates[0]).add(6, "days").format("YYYY-MM-DD"),
    // ];
    range = [
        this.dates[0].format("YYYY-MM-DD"),
    ];
    menu = false;
    hours = { min: 0, max: 24 };
    showOtherInstructors = true;
    endListener = () => { };
    previous() {
        const params = {};
        params.dateFrom = moment(this.range[0])
            .subtract(this.dates.length, "days")
            .format("YYYY-MM-DD");
        if (this.dates.length > 1) {
            params.dateTo = moment(params.dateFrom)
                .add(this.dates.length - 1, "days")
                .format("YYYY-MM-DD");
        }
        if (this.$route.name === 'InstructorsTimeScheduleWithDate') {
            this.$router.push({
                name: 'InstructorsTimeSchedule',
                params: params,
            });
        }
        this.range = Object.values(params);
        this.changeDate();
    }
    next() {
        const params = {};
        params.dateFrom = moment(this.range[0])
            .add(this.dates.length, "days")
            .format("YYYY-MM-DD");
        if (this.dates.length > 1) {
            params.dateTo = moment(params.dateFrom)
                .add(this.dates.length - 1, "days")
                .format("YYYY-MM-DD");
        }
        if (this.$route.name === 'InstructorsTimeScheduleWithDate') {
            this.$router.push({
                name: 'InstructorsTimeSchedule',
                params: params,
            });
        }
        this.range = Object.values(params);
        this.changeDate();
    }
    changeToActualWeek(changeDate) {
        const day = moment().day() > 0 ? moment().day() - 1 : 6;
        this.range = [
            moment()
                .subtract(day, "days")
                .format("YYYY-MM-DD"),
            moment()
                .subtract(day, "days")
                .add(6, "days")
                .format("YYYY-MM-DD"),
        ];
        if (changeDate) {
            this.dates = [moment()];
            this.changeDate();
        }
    }
    changeDate() {
        this.hours = { min: 24, max: 0 };
        this.menu = false;
        if (this.range.length === 0) {
            this.dates = [moment()];
        }
        this.range.sort();
        let from = moment(this.range[0]);
        if (this.range.length === 1) {
            this.dates = [from];
            const hours = OperatingHoursMapper.getByDay(from);
            this.hours = {
                min: hours.openFrom,
                max: hours.openTo,
            };
            return;
        }
        if (this.range.length === 2 &&
            from.isSame(moment(this.range[1]), "day")) {
            this.dates = [from];
            this.range.splice(1, 1);
            return;
        }
        let to = moment(this.range[1]);
        this.dates = [];
        do {
            this.dates.push(_.cloneDeep(from));
            this.hours.min = Math.min(OperatingHoursMapper.getByDay(from).openFrom, this.hours.min);
            this.hours.max = Math.max(OperatingHoursMapper.getByDay(from).openTo, this.hours.max);
            from.add(1, "days");
        } while (from.isSameOrBefore(to, "days"));
    }
    async addScrollEvents() {
        await this.$nextTick();
        const wrapper = document.querySelector("#multiple-scrollbar-wrapper");
        const scrollbar = document.querySelector("#multiple-scrollbar");
        const innerTable = document.querySelector(".v-data-table__wrapper table");
        if (innerTable === null || scrollbar === null || wrapper === null) {
            return;
        }
        scrollbar.style.width = innerTable.offsetWidth + "px";
        wrapper.addEventListener("scroll", async () => {
            for (const element of document.querySelectorAll(".v-data-table__wrapper")) {
                await this.$nextTick();
                element.scrollLeft = wrapper.scrollLeft;
            }
        });
        for (const triggerElement of document.querySelectorAll(".v-data-table__wrapper")) {
            triggerElement.addEventListener("scroll", async () => {
                for (const element of document.querySelectorAll(".v-data-table__wrapper")) {
                    if (element !== triggerElement) {
                        element.scrollLeft = triggerElement.scrollLeft;
                    }
                    await this.$nextTick();
                    wrapper.scrollLeft = triggerElement.scrollLeft;
                }
            });
        }
    }
    get rangeString() {
        if (this.range.length === 0) {
            return '';
        }
        let rangeString = moment(this.range[0])
            .toDate()
            .toLocaleDateString();
        if (this.range.length === 2) {
            rangeString =
                rangeString +
                    ' - ' +
                    moment(this.range[1]).toDate().toLocaleDateString();
        }
        return rangeString;
    }
    updateDatesFromRoute() {
        if (this.$route.params.date) {
            this.dates = [moment(this.$route.params.date, 'YYYY-MM-DD')];
            this.range = [this.dates[0].format("YYYY-MM-DD")];
        }
        if (this.$route.params.dateFrom) {
            this.dates = [moment(this.$route.params.dateFrom, 'YYYY-MM-DD')];
            this.range = [this.dates[0].format("YYYY-MM-DD")];
            if (this.$route.params.dateTo) {
                this.range.push(moment(this.$route.params.dateTo, 'YYYY-MM-DD').format("YYYY-MM-DD"));
            }
        }
    }
    mounted() {
        // Dočasně přesunuto do App.vue
        //this.endListener = await this.$store.dispatch('instructorTable/listen');
        setTimeout(async () => {
            this.updateDatesFromRoute();
            this.changeDate();
            document.addEventListener('instructorTableWidthChanged', this.addScrollEvents);
            document.addEventListener('addClient', this.addClient);
            document.addEventListener('editClient', this.editClient);
        });
    }
    async addClient(object) {
        this.addClientDialogProps = object.detail;
        this.$refs['addClientDialog'].open(this.addClientDialogProps.row);
    }
    async editClient(object) {
        this.addClientDialogProps = object.detail;
        this.$refs['addClientDialog'].open(this.addClientDialogProps.row, this.addClientDialogProps.cell);
    }
    logFailedReservation(cell, table, row, error) {
        let instructorId = '';
        let instructorName = 'Unknown';
        if (row.rowType === InstructorTableRowType.INSTRUCTOR) {
            const instructorRow = row;
            instructorId = instructorRow.instructorId;
            const instructor = this.$store.getters['instructor/get'](instructorId);
            if (instructor) {
                instructorName = `${instructor.data.name} ${instructor.data.surname}`;
            }
        }
        else if (row.rowType === InstructorTableRowType.BLOCK) {
            const blockRow = row;
            instructorId = String(blockRow.blockId);
            instructorName = 'Block: ' + blockRow.blockId;
        }
        const dateStr = table.date.format('YYYY-MM-DD');
        const entityId = createReservationEntityId(dateStr, instructorId, cell.hour);
        const failedData = {
            date: dateStr,
            instructorId,
            instructorName,
            hour: cell.hour,
            length: cell.length,
            service: cell.service,
            clients: cell.clients.map(c => ({
                name: c.name,
                age: c.age,
            })),
            phone: cell.phone,
            note: cell.note,
            price: cell.price,
            isPrepaid: cell.isPrepaid,
            voucherBlockedValue: cell.voucherBlockedValue,
            errorMessage: error instanceof Error ? error.message : String(error),
            attemptedAt: new Date().toISOString(),
        };
        logActivity('CREATE', 'reservation_failed', entityId, null, failedData);
    }
    async saved(cell) {
        const table = this.$store.getters['instructorTable/get'](this.addClientDialogProps.from);
        if (table === undefined) {
            Snackbar.error('Chyba ukládání!');
            return;
        }
        const row = table.rows.find(x => (x.rowType === InstructorTableRowType.INSTRUCTOR
            && x.instructorId === this.addClientDialogProps.row.instructorId)
            ||
                (x.rowType === InstructorTableRowType.BLOCK
                    && x.blockId === this.addClientDialogProps.row.blockId));
        if (row === undefined) {
            Snackbar.error('Chyba ukládání!');
            return;
        }
        // Overlap validation for instructor rows
        if (row.rowType === InstructorTableRowType.INSTRUCTOR) {
            const instructorRow = row;
            // Get reserved cells for this instructor row
            const reservedCells = instructorRow.cells
                .filter(c => c.cellType === InstructorTableCellType.RESERVED)
                .map(c => {
                const reservedCell = c;
                return {
                    type: 'RESERVED',
                    hour: reservedCell.hour,
                    length: reservedCell.length,
                    service: (reservedCell.service || 'ski'),
                    clientNames: reservedCell.clients?.map(client => client.name) || [],
                };
            });
            // Build excludeCellId for edit operations
            const excludeCellId = this.addClientDialogProps.cell !== undefined
                ? `${table.date.format('YYYY-MM-DD')}_${instructorRow.instructorId}_${this.addClientDialogProps.cell.hour}`
                : undefined;
            // Validate overlap
            const validation = validateOverlap(reservedCells, {
                instructorId: instructorRow.instructorId,
                hour: this.addClientDialogProps.hour ?? cell.hour,
                length: cell.length,
                excludeCellId,
            });
            if (!validation.valid && validation.error) {
                // Fill in instructor name for the error message
                if (validation.error.conflict) {
                    const instructor = this.$store.getters['instructor/get'](instructorRow.instructorId);
                    validation.error.conflict.instructorName = instructor
                        ? `${instructor.data.name} ${instructor.data.surname}`
                        : 'Neznámý';
                    Snackbar.error(formatOverlapError(validation.error.conflict));
                }
                else {
                    Snackbar.error(validation.error.message);
                }
                return; // Abort save
            }
        }
        if (this.addClientDialogProps.cell !== undefined) {
            row.cells.splice(row.cells.findIndex(x => x.hour === this.addClientDialogProps.cell?.hour), 1);
            if (row.rowType === InstructorTableRowType.INSTRUCTOR) {
                for (let i = 0; i < this.addClientDialogProps.cell?.length; i++) {
                    const availableCell = new InstructorTableAvailableCell(row);
                    availableCell.hour = (this.addClientDialogProps.hour ?? -1) + i;
                    row.cells.push(availableCell);
                }
            }
        }
        const cells = row.cells.filter((x) => x.hour >= (this.addClientDialogProps.hour ?? -1) && x.hour < (this.addClientDialogProps.hour ?? -1) + cell.length);
        if (row.rowType === InstructorTableRowType.INSTRUCTOR) {
            if (cells.length !== cell.length) {
                Snackbar.error('Instruktor si během ukládání odebral, že je k dispozici!');
                return;
            }
            else if (cells.some((x) => x.cellType !== InstructorTableCellType.AVAILABLE)) {
                Snackbar.error('Instruktor se snaží přidat buňku, kde je nyní pauza nebo jiný klient!');
                return;
            }
            else {
                cells.forEach((c) => { row.cells.splice(row.cells.indexOf(c), 1); });
            }
        }
        else if (cells.length !== 0) {
            Snackbar.error('Instruktor se snaží přidat buňku, kde je nyní pauza nebo jiný klient!');
            return;
        }
        row.cells.push(cell);
        try {
            await this.$store.dispatch('instructorTable/update', this.$store.getters['instructorTable/get'](this.addClientDialogProps.from));
        }
        catch (error) {
            // ROLLBACK: Remove cell from local state since save failed
            const cellIndex = row.cells.indexOf(cell);
            if (cellIndex !== -1) {
                row.cells.splice(cellIndex, 1);
            }
            // Log the failed reservation attempt for data recovery
            this.logFailedReservation(cell, table, row, error);
            // Version conflict handling (FR-004)
            const errorMessage = error instanceof Error ? error.message : String(error);
            if (errorMessage.includes('rozvrh') || errorMessage.includes('VERSION_CONFLICT')) {
                Snackbar.error('Někdo jiný upravil tento rozvrh. Prosím obnovte stránku a zkuste to znovu.');
            }
            else {
                Snackbar.error('Chyba při ukládání: ' + errorMessage);
            }
            return;
        }
        // SUCCESS: Now send notification (save confirmed)
        await cell.notifyInstructor(`Nová výuka dne ${table.date.format('D. M. YYYY')} od ${cell.hour}:00`, NotificationTypes.SUCCESS, { name: 'InstructorsTimeScheduleWithDate', params: { date: table.date.format('YYYY-MM-DD') } });
        this.$refs.addClientDialog.reset();
    }
    beforeDestroy() {
        this.endListener();
        document.removeEventListener('instructorTableWidthChanged', this.addScrollEvents);
        document.removeEventListener('addClient', this.addClient);
        document.removeEventListener('editClient', this.editClient);
    }
    get routeParams() {
        return this.$route.params;
    }
    get userLoggedIn() {
        return this.$store.getters['user/isLoggedIn'];
    }
    onRouteParamsChange() {
        this.updateDatesFromRoute();
        this.changeDate();
    }
};
__decorate([
    Ref('controlsRow')
], InstructorsTimeSchedule.prototype, "controlsRow", void 0);
__decorate([
    Watch('routeParams', { deep: true })
], InstructorsTimeSchedule.prototype, "onRouteParamsChange", null);
InstructorsTimeSchedule = __decorate([
    Component({
        methods: { isDesktop },
        components: {
            InstructorsTable,
            AddClientForm
        },
    })
], InstructorsTimeSchedule);
export default InstructorsTimeSchedule;
